import { AbstractControl, FormArray, FormGroup } from '@angular/forms'
import { Answer, answerForQuestion } from './Answer'
import { BookingRequest } from './BookingRequest'
import { BookingSlot } from './BookingSlot'
import { FormStep } from '../booking-form/booking-form.component'
import { NGBDateTimeAdapter } from '../utilities/NgbDateTimeAdapter'
import { NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap'
import { Question } from './Question'
import { Availability } from './Availability'
import { LineItemDTO } from '../services/DTOs/LineItemDTO'
import { OrderDTO } from '../services/DTOs/OrderDTO'
import { v4 as uuidv4 } from 'uuid'
import { Order } from './Order'

export class BookingRequestFactory {

    private ngbDateAdapter = new NgbDateNativeAdapter()
    private ngbTimeAdapter = new NGBDateTimeAdapter()

    constructor(
        private form: FormGroup,
        private utmSource: string | null,
        private utmMedium: string | null,
        private utmCampaign: string | null
    ) { }

    public make() {
        const bookingSlotForm = this.form.get(FormStep[FormStep.BookingSlot]) as FormGroup
        const bookingDetailsForm = this.form.get(FormStep[FormStep.BookingDetails]) as FormGroup
        const paymentDetailsForm = this.form.get(FormStep[FormStep.PaymentDetails]) as FormGroup
        const depositForm = this.form.get(FormStep[FormStep.Deposit]) as FormGroup
        const orderForm = this.form.get('Order') as FormGroup
        const lineItemsArray = orderForm.get('lineItems') as FormArray
        const availability = bookingSlotForm.get('availability')?.value as Availability | null
        const reasonId = bookingSlotForm.get('selectedReasonId')?.value
        const basketItems = availability?.bookingUpsellMenu(reasonId)?.isPaid ? [] : lineItemsArray.controls.map(control => {
            return {
                productId: control.get('productId')?.value,
                skuId: control.get('skuId')?.value,
                quantity: control.get('quantity')?.value
            }
        })
        const questions = bookingDetailsForm.get('questions') as FormArray
        const answers = questions.controls
            .map(questionControl => this.makeAnswerFromQuestionControlOrNull(questionControl))
            .filter(answer => answer !== null) as Answer[]
        let bookingSlot = bookingSlotForm.get('bookingSlot')?.value
        if (bookingSlot === undefined) {
            const availabilityControl = bookingSlotForm?.get('availability')
            const availability = availabilityControl?.value as Availability
            const ngbDate = bookingSlotForm.get('date')?.value
            const ngbTime = bookingSlotForm.get('time')?.value
            const date = this.ngbDateAdapter.toModel(ngbDate)!
            const time = this.ngbTimeAdapter.toModel(ngbTime)!
            const dateTime = availability.getDateTimeForBookingSlotDateAndTime(
                date,
                time
            )
            bookingSlot = new BookingSlot(dateTime)
        }
        const phoneNumber = bookingDetailsForm.get('phoneNumber')?.value
        const e164PhoneNumber = phoneNumber?.e164Number ?? null
        return new BookingRequest(
            bookingSlotForm.get('bookingRequestId')?.value,
            bookingSlot,
            bookingSlotForm.get('selectedAreaId')?.value,
            bookingDetailsForm.get('firstName')?.value,
            bookingDetailsForm.get('lastName')?.value,
            bookingDetailsForm.get('emailAddress')?.value,
            phoneNumber ? e164PhoneNumber : null,
            bookingSlotForm.get('partySize')?.value,
            bookingDetailsForm.get('notes')?.value,
            bookingDetailsForm.get('agreedToMarketing')?.value,
            bookingDetailsForm.get('agreedToTerms')?.value,
            bookingSlotForm.get('selectedReasonId')?.value,
            bookingSlotForm.get('selectedEventId')?.value,
            basketItems,
            answers,
            depositForm.get('paymentIntentId')?.value,
            bookingSlotForm.get('requiresWheelchairAccess')?.value,
            bookingSlotForm.get('requiresDogFriendly')?.value,
            bookingSlotForm.get('requiresPramAccessible')?.value,
            bookingSlotForm.get('requiresHighchairFriendly')?.value,
            this.utmSource,
            this.utmMedium,
            this.utmCampaign
        )
    }

    private makeAnswerFromQuestionControlOrNull(questionControl: AbstractControl) {
        const question = questionControl.get('question')?.value as Question
        return answerForQuestion(question, questionControl.get('answer')?.value)
    }
}
